<template>
    <c-dropdown-divider />
</template>
